<nav
  class="grid grid-cols-3 gap-4 bg-blue-50 px-12 py-6"
  style="grid-template-columns: 225px 1fr 225px"
>
  <div class="flex flex-row items-center gap-4">
    @if (isMenuVisible()) {
    <button matIconButton class="text-dnv-secondary" (click)="onMenuButtonClick()">
      <mat-icon [fontIcon]="isButtonMenuOpen() ? 'close' : 'menu'"></mat-icon>
    </button>
    }

    <a routerLink="/pns" class="flex-shrink-0 w-13 h-[75px] flex items-center">
      <img class="w-full h-full object-contain" ngSrc="media/enac-logo.png" alt="ENAC" height="75" width="52" priority />
    </a>
    <h1 class="text-l md:text-2xl font-semibold max-w-full">{{ titleKey() | translate }}</h1>
  </div>

  <div class="flex items-center gap-2 justify-center">
    @if (layoutService.searchBarVisible()) {
      <dnv-searchbar></dnv-searchbar>
    } @else {
      <div></div>
    }

    @if (layoutService.searchBarVisible()) {
      <button
        class="relative bg-dnv-secondary hover:bg-dnv-secondary/70 p-2 rounded-full cursor-pointer text-white flex items-center justify-center"
        (click)="openFilterDialog()"
      >
        <mat-icon
          aria-hidden="false"
          aria-label="Icona filtri"
          fontIcon="tune"
          class="size-4"
        ></mat-icon>
        @if (isAnyFilterActive()) {
          <span
            class="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500 ring-2 ring-white"
          ></span>
        }
      </button>
    }

  </div>

  <div class="flex items-center justify-end gap-2">
    @if (layoutService.userButtonVisible()) {
      @if(currentUser(); as user) {
        <span class="text-md font-semibold">{{user.firstName}} {{user.lastName}}</span>
      }

      <button
        [matMenuTriggerFor]="userMenu"
        [attr.aria-label]="'NAV.ARIA_LABELS.USER_MENU' | translate"
        class="bg-dnv-secondary p-2 rounded-full cursor-pointer hover:bg-dnv-secondary/80 text-white flex items-center justify-center"
      >
        <mat-icon
          aria-hidden="false"
          aria-label="Icona filtri"
          fontIcon="person"
          class="size-4"
        ></mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="authService.logout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    } @else {
      <div></div>
    }
  </div>

</nav>
